import { CancelSelectedFile, DeleteStrikerIcon } from "icons";
import styles from "./styles.module.scss";
import { DownloadIcon } from "icon-components/DownloadIcon";
import { FILE_EXTENSION_ICONS } from "pages/notes/constants";
import { UseLazyApiCallV2 } from "hooks";
import { Spin } from "antd";
import { useLanguageTranslator } from "hooks/use-language-translator";

export const UploadedFiles = ({
  files,
  note_id,
  refetchnoteAttachments,
  filesLoading,
}) => {
  const { translator } = useLanguageTranslator();
  const uploadFilesTrans = translator("caseDetail.uploadFiles");
  const [delete_attachment, { data, isLoading, error }] = UseLazyApiCallV2({
    url: "/delete_attachment",
    method: "POST",
  });
  const [download_attachment, { isLoading: downloading }] = UseLazyApiCallV2({
    url: "/download_attachment",
    method: "POST",
  });

  async function deleteNoteAttachment({ note_id, uuid }) {
    try {
      const res = await delete_attachment({
        params: {
          uuid,
          note_id,
        },
      });
      if (res?.success) {
        refetchnoteAttachments();
      }
    } catch (error) {}
  }

  async function handleClickDownload(uuid) {
    try {
      const res = await download_attachment({
        params: {
          uuid,
        },
      });
      if (res?.download_url) {
        const link = document.createElement("a");
        link.href = res.download_url;
        link.download = ""; // or provide filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log({ error });
    }
  }

  return (
    <Spin spinning={isLoading || downloading || filesLoading}>
      <div className={styles.uploadedFiles}>
        <div className={styles.header}>
          <div className={styles.heading}>{uploadFilesTrans.uploadedFiles}</div>
          <div className={styles.totalFiles}>
            {uploadFilesTrans.totalFiles}: <span>{files?.length}</span>
          </div>
        </div>
        <div className={styles.files}>
          {files?.map((item) => {
            const fileExtension = item?.filename?.split(".")[1];
            const FileExtensionIcon = FILE_EXTENSION_ICONS[fileExtension];
            return (
              <div className={styles.singleFile} key={item.key}>
                <div className={styles.iconAndName}>
                  <FileExtensionIcon />
                  <div>{item.filename}</div>
                </div>
                <div className={styles.actionIcons}>
                  <div
                    className={styles.downloadIcon}
                    onClick={() => handleClickDownload(item?.key)}
                  >
                    <DownloadIcon fill="#FF6170" />
                  </div>

                  <div
                    className={styles.deleteIcon}
                    onClick={() =>
                      deleteNoteAttachment({ uuid: item?.key, note_id })
                    }
                  >
                    <DeleteStrikerIcon
                      style={{ cursor: "pointer", userSelect: "none" }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Spin>
  );
};
